import '../styles/Grille.css';

import { useTranslation } from 'react-i18next';

function Grille({rows, itemNow}) {
    const { t } = useTranslation();
    console.log('rows', rows, 'itemNow', itemNow)
	
    const anyColorMatch = (colors1, colors2) => {
        return colors2.some(color => colors1.includes(color));
    };

    const allColorsMatch = (colors1, colors2) => {
        return colors1.every(color => colors2.includes(color));
    };
    
    const extraColorsInSecond = (colors1, colors2) => {
        return colors1.every(color => colors2.includes(color)) && colors2.some(color => !colors1.includes(color));
    };

    return (
		<div className="grille">
            <div className="grille-row grille-row-head">
                <div className="grille-col">{t('grilleitem.item')}</div>
                <div className="grille-col">{t('grilleitem.game')}</div>
                <div className="grille-col">{t('grilleitem.platform')}</div>
                <div className="grille-col">{t('grilleitem.type')}</div>
                <div className="grille-col">{t('grilleitem.colors')}</div>
                <div className="grille-col">{t('grilleitem.location')}</div>
            </div>
            {rows.map(({ rowsLength, id, item, game, anneeJeu, type, color, location, plateforme_jeu, img_item  }) => {
                // Convertir les chaînes de caractères en tableaux
                let couleurs1 = itemNow.couleur_item
                let couleurs2 = color

                couleurs1 = couleurs1 ? couleurs1.includes(',') ? couleurs1.split(',').map(couleur => couleur.trim()) : [couleurs1.trim()] : null;
                couleurs2 = couleurs2 ? couleurs2.includes(',') ? couleurs2.split(',').map(couleur => couleur.trim()) : [couleurs2.trim()] : null;

                // Vérifier si l'une des couleurs de couleurs2 est dans couleurs1
                let couleurTrouvee = couleurs2 && couleurs1 ? anyColorMatch(couleurs1, couleurs2) : false;
                // Vérifier si toutes les couleurs de couleurs1 sont dans couleurs2
                let toutesCouleursTrouvees = couleurs2 && couleurs1 ? allColorsMatch(couleurs1, couleurs2): false;
                // Vérifier si toutes les couleurs de couleurs1 sont dans couleurs2
                let couleursSupplementaires = couleurs2 && couleurs1 ? extraColorsInSecond(couleurs1, couleurs2): false;


                return (
                    <div className="grille-row" key={rowsLength}>
                        
                        <div className={`grille-cell ${id === itemNow.id_item ? 'green' : 'red'}`} >
                            <div className='grille-cell-detail'>
                                <span><img src={`/images/items/${img_item}`} alt={item.nom_item} /></span><br />
                                <span>{item}</span>
                            </div>
                        </div>
                        { game === itemNow.nom_jeu ?
                            <div className='grille-cell green'>{game} ({anneeJeu})</div>
                            : anneeJeu < itemNow.annee_jeu ? 
                                <div className='grille-cell red after'>{game} ({anneeJeu}) <img src='/images/assets/arrow_up.png' alt='arrow_up' /></div>
                                : <div className='grille-cell red before'>{game} ({anneeJeu}) <img src='/images/assets/arrow_down.png' alt='arrow_down' /></div>
                        }
                        <div className={`grille-cell ${plateforme_jeu === itemNow.plateforme_jeu ? 'green' : 'red'}`} >{plateforme_jeu}</div>
                        <div className={`grille-cell ${type === itemNow.type_item ? 'green' : 'red'}`} >{type}</div>
                        <div className={`grille-cell ${toutesCouleursTrouvees && !couleursSupplementaires ? 'green' : couleurTrouvee ? 'orange' : 'red'}`}>{color}</div>
                        <div className={`grille-cell ${location === itemNow.localisation_item ? 'green' : 'red'}`} >{location}</div>
                    </div>
                );
            })}
        </div>
	)
}

export default Grille
